/*
 * schemaAttributes Reducer
 */
import get from 'lodash.get';

import { SCAFFOLD_DATA_LOAD_SUCCEEDED } from '../scaffoldData/constants';
import { RESET_STATE } from '../auth/constants';

const initialState = {};

type State = {};

type Action = {
    +type: string,
    +payload: Object
};

export default function(state: State = initialState, action?: Action) {
    if (!action) return state;
    switch (action.type) {
        case SCAFFOLD_DATA_LOAD_SUCCEEDED: {
            const schemaAttributes = get(
                action,
                'payload.entities.schemaAttributes',
                {}
            );
            return {
                ...schemaAttributes
            };
        }
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
